import { render, staticRenderFns } from "./taskCommentsTab.vue?vue&type=template&id=34c3fbf9&scoped=true&"
import script from "./taskCommentsTab.vue?vue&type=script&lang=js&"
export * from "./taskCommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./taskCommentsTab.vue?vue&type=style&index=0&id=34c3fbf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3fbf9",
  null
  
)

export default component.exports